<div class="mainBody">
    <div class="dmv-search-results inner-home">
        <div class="container">
            <div class="row no-margin">
               
                <div class="col-12 col-sm-12 mt-4">
                    <div id="searchResu">Email Address Changed</div>
                    <p id="addthereco"><span class="textLink">&nbsp;</span></p>
                </div>
             
           
               
                   
                  
                        <div class="container  mt-4 mb-5">
                            <span class="runningText" [innerHTML]="userStoreService?.outComeText">
                        <!-- Thank you! Your email address has been changed successfully. -->
                       
                    </span>

                       </div>
                       
                

                   
              
            </div>

            <div class="container m-auto text-center">
                            <a><button
                        class="btn btn-primary  btn-continue m-auto" (click)="continue()">Continue <i
                            class="fa fa-chevron-right text-right"></i></button></a></div>
        </div>
    </div>
</div>